import { useEffect, useState } from "react";
import { useConfigure, useInfiniteHits } from "react-instantsearch";

import { useSearchBox } from "react-instantsearch";

import { KYDMultiSelect } from "src/ui";

const AlgoliaMultiSelect = ({
  label,
  placeholder,
  values: _values,
  onChange,
  searchKey,
}: {
  label: string;
  placeholder: string;
  values: any[];
  onChange: (vals: any[]) => void;
  searchKey: string;
}) => {
  const { items } = useInfiniteHits();
  const { refine } = useSearchBox();
  const [options, setOptions] = useState<any[]>([]);
  const [values, setValues] = useState<any[]>(_values);

  useEffect(() => {
    setValues(_values);
  }, [_values]);

  useConfigure({
    restrictSearchableAttributes: [searchKey],
    hitsPerPage: 10,
  });

  useEffect(() => {
    switch (searchKey) {
      case "name":
        setOptions(
          items.map((item) => ({ label: item.name, value: item.objectID }))
        );
        break;
      case "performers.name":
        // get unique performers
        setOptions(
          items
            .map((item) => {
              const performers =
                item.performers?.map((p) => ({
                  label: p.name,
                  value: p.id || p.name,
                })) || [];
              return performers;
            })
            .flat()
            .filter(
              (performer, index, self) =>
                index === self.findIndex((p) => p.value === performer.value)
            )
        );
        break;
      case "venues.name":
        // get unique venues
        setOptions(
          items
            .map((item) => {
              const venues =
                item.venues?.map((v) => ({
                  label: v?.name,
                  value: v?.id || v?.name,
                })) || [];
              return venues;
            })
            .flat()
            .filter((venue) => Boolean(venue?.value))
            .filter(
              (venue, index, self) =>
                index === self.findIndex((p) => p.value === venue.value)
            )
        );
        break;
      default:
        break;
    }
  }, [items, searchKey]);

  useEffect(() => {
    setValues(
      _values.map((v) => {
        const option = options.find((o) => o.value === v.value);
        return option || v;
      })
    );
  }, [options, _values]);

  return (
    <KYDMultiSelect
      id={searchKey}
      onInputChange={refine}
      label={label}
      placeholder={placeholder}
      options={options}
      values={values}
      onChange={onChange}
    />
  );
};

export default AlgoliaMultiSelect;
